module.exports = __webpack_public_path__ + "static/media/table_footer_column.343ba75c.png";